// extracted by mini-css-extract-plugin
export default {"numberInput":"NumberInput_numberInput__kVYnF"};